import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Flex } from '@stepstone-genesis/components';
import { SocialAuthProvider } from '../../redux/features/facebook/SocialAuthProvider.js';
export const SocialsWrapper = ({ children }) => {
    return (_jsx(Flex, { flxDirection: 'column', gap: 'spaceM', children: _jsx(SocialAuthProvider, { children: children }) }));
};
//# sourceMappingURL=SocialsWrapper.js.map